import { render, staticRenderFns } from "./TwitterCallbackPage.vue?vue&type=template&id=1f5961f8&scoped=true&"
import script from "./TwitterCallbackPage.vue?vue&type=script&lang=js&"
export * from "./TwitterCallbackPage.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCallbackPage.vue?vue&type=style&index=0&id=1f5961f8&scoped=true&lang=css&"
import style1 from "./TwitterCallbackPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5961f8",
  null
  
)

export default component.exports